import { api, getConfig } from './api';

export interface PhotoStatus { photoId: string; status: 'processing' | 'ready' | 'no-subject' | 'failed'; photoKey?: string; stickerKey?: string; reason?: string }

/** Upload a dish photo through the presigned form, then wait for the sticker Lambda (up to ~2 min). */
export async function uploadDishPhoto(token: string, file: File, onStage: (s: string) => void): Promise<PhotoStatus> {
  if (!file.type.startsWith('image/')) throw new Error('Please choose a photo (JPG, PNG, HEIC, WebP)');
  if (file.size > 15 * 1024 * 1024) throw new Error('Photo is larger than 15 MB');
  const up = await api<{ photoId: string; upload: { url: string; fields: Record<string, string> } }>('POST', '/photos', { token });
  onStage('uploading');
  const form = new FormData();
  for (const [k, v] of Object.entries(up.upload.fields)) form.append(k, v);
  form.append('Content-Type', file.type);
  form.append('file', file);
  const res = await fetch(up.upload.url, { method: 'POST', body: form });
  if (res.status !== 204) throw new Error(`Upload failed (${res.status})`);
  onStage('processing');
  const t0 = Date.now();
  while (Date.now() - t0 < 150_000) {
    const st = await api<PhotoStatus>('GET', `/photos/${up.photoId}`, { token });
    if (st.status !== 'processing') return st;
    await new Promise((r) => setTimeout(r, 2500));
  }
  throw new Error('Still processing; try again in a minute');
}

export async function photoUrls(token: string, photoId: string) {
  const [st, cfg] = await Promise.all([api<PhotoStatus>('GET', `/photos/${photoId}`, { token }), getConfig()]);
  return {
    status: st.status,
    photo: st.photoKey ? `${cfg.mediaUrl}/${st.photoKey}` : undefined,
    sticker: st.stickerKey ? `${cfg.mediaUrl}/${st.stickerKey}` : undefined,
  };
}
